import React from 'react';

type RibbonProps = {
  color?: string;
  height?: number;
  width?: number;
};

export function RibbonStarOutline({ color = '#000000', width = 33, height = 37 }: RibbonProps): JSX.Element {
  return (
    <svg fill='none' height={height} viewBox='0 0 33 37' width={width} xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M6.15139 21L1 28.2014L5.8696 29.3155L7.81744 36L13 26.5942'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
      />
      <path
        d='M26.4193 21L32 28.2014L26.7246 29.3155L24.6144 36L19 26.5942'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
      />
      <path
        d='M17.218 2.97002L19.9285 5.05042L23.4051 4.885C23.6559 4.87314 23.9034 4.94356 24.1066 5.08457C24.3097 5.22558 24.4563 5.42871 24.5219 5.66024L25.4318 8.87056L28.3463 10.693C28.5579 10.8249 28.7158 11.0221 28.7935 11.2517C28.8712 11.4813 28.8641 11.7295 28.7734 11.9547L27.5333 15.0557L28.7734 18.1623C28.8625 18.3866 28.8688 18.6333 28.7911 18.8614C28.7134 19.0896 28.5565 19.2856 28.3463 19.417L25.4318 21.2394L24.5219 24.4497C24.4563 24.6813 24.3097 24.8844 24.1066 25.0254C23.9034 25.1664 23.6559 25.2368 23.4051 25.225L19.9285 25.0596L17.218 27.1456C17.0223 27.2959 16.7787 27.3778 16.5275 27.3778C16.2764 27.3778 16.0328 27.2959 15.8371 27.1456L13.1265 25.0553L9.64992 25.2208C9.39893 25.2327 9.15121 25.1623 8.94783 25.0213C8.74444 24.8803 8.59761 24.6772 8.53166 24.4455L7.62326 21.2352L4.70873 19.4128C4.49792 19.2819 4.34049 19.086 4.26276 18.8576C4.18503 18.6292 4.19171 18.3823 4.28168 18.1581L5.52028 15.0557L4.28168 11.9477C4.19009 11.7226 4.18255 11.4741 4.26034 11.2443C4.33813 11.0145 4.4965 10.8173 4.70873 10.686L7.62326 8.86355L8.53166 5.65323C8.59761 5.42159 8.74444 5.21842 8.94783 5.07743C9.15121 4.93643 9.39893 4.86606 9.64992 4.87799L13.1265 5.05042L15.8371 2.97002C16.0328 2.81972 16.2764 2.73779 16.5275 2.73779C16.7787 2.73779 17.0223 2.81972 17.218 2.97002Z'
        fill='white'
        fillOpacity='0.2'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
      />
      <path
        d='M15.9714 8.89482C16.1994 8.44001 16.8539 8.44001 17.0819 8.89482L18.6185 11.9604C18.7087 12.1405 18.8822 12.2654 19.0829 12.2949L22.499 12.7962C23.0058 12.8705 23.2081 13.4876 22.8421 13.843L20.3757 16.2389C20.2308 16.3797 20.1645 16.5818 20.1983 16.7801L20.773 20.1555C20.8582 20.6563 20.3287 21.0377 19.8746 20.8025L16.8137 19.2177C16.6338 19.1246 16.4194 19.1246 16.2396 19.2177L13.1787 20.8025C12.7245 21.0377 12.195 20.6563 12.2803 20.1555L12.855 16.7801C12.8887 16.5818 12.8225 16.3797 12.6776 16.2389L10.2111 13.843C9.84521 13.4876 10.0475 12.8705 10.5543 12.7962L13.9704 12.2949C14.1711 12.2654 14.3445 12.1405 14.4348 11.9604L15.9714 8.89482Z'
        fill={color}
      />
    </svg>
  );
}
